// extracted by mini-css-extract-plugin
module.exports = {"cost-saving-Retailers":"Retailers_cost-saving-Retailers__IfsN0"};